import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Bar from './Bar';
import Label from './Label';

const styles = theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(1.5, 0),
  },
});

const Row = ({
  labelRefs,
  className,
  classes,
  itemName,
  BarProps,
  LabelProps,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      <Bar
        className={classes.bar}
        {...BarProps}
      />
      <Label
        className={classes.label}
        color="primaryGray"
        {...LabelProps}
        ref={(ref) => {
          if (!labelRefs.current) {
            // eslint-disable-next-line no-param-reassign
            labelRefs.current = {};
          }

          // eslint-disable-next-line no-param-reassign
          labelRefs.current[itemName] = ref;
        }}
      />
    </div>
  );
};

Row.defaultProps = {
  className: '',
};

Row.propTypes = {
  labelRefs: PropTypes.object.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  itemName: PropTypes.string.isRequired,
  BarProps: PropTypes.object.isRequired,
  LabelProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(Row);
